module.exports = __webpack_public_path__ + "static/img/activity_four.f449bab1.jpg";